import * as React from "react";
import { MenuItem } from "components/bootstrap";
import EntityCollectionModal from "collections/components/EntityCollectionModal";
import i18n from "i18n";
const manageCollectionTitle = (title) => i18n.t("entity_collection_actions.manage_title", { ns: "enterprise_collections", title });
export const DashboardCollectionsModal = React.forwardRef(
  ({ dashboard }, ref) => /* @__PURE__ */ React.createElement(
    EntityCollectionModal,
    {
      entityId: dashboard.id,
      entityType: "dashboard",
      ref,
      title: manageCollectionTitle(dashboard.title)
    }
  )
);
export const SearchManageCollectionsModal = React.forwardRef(({ search }, ref) => /* @__PURE__ */ React.createElement(
  EntityCollectionModal,
  {
    entityId: search.id,
    entityType: "search",
    ref,
    title: manageCollectionTitle(search.title)
  }
));
const ShareCollectionsModalInner = ({ entity, entityType, onClose = void 0 }, ref) => /* @__PURE__ */ React.createElement(
  EntityCollectionModal,
  {
    entityId: entity.id,
    entityType,
    ref,
    onClose,
    title: manageCollectionTitle(entity.title)
  }
);
export const ShareCollectionsModal = React.forwardRef(ShareCollectionsModalInner);
const EntityCollectionActions = ({ modalRef }) => /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => {
  var _a;
  return (_a = modalRef()) == null ? void 0 : _a.toggle();
} }, i18n.t("entity_collection_actions.manage_collections", { ns: "enterprise_collections" }));
export const SearchEntityCollectionActions = ({ loaded, search: _, modalRefs }) => {
  const { searchManageCollectionModal } = modalRefs;
  return loaded ? /* @__PURE__ */ React.createElement(EntityCollectionActions, { modalRef: () => {
    var _a;
    return (_a = searchManageCollectionModal()) == null ? void 0 : _a.toggle();
  } }) : null;
};
export default EntityCollectionActions;
